// import { AlertModalProps } from "../Alert"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"

export type InformativeIconItem = {
   iconName: IconProps["name"]
   // vitalValue?: AlertModalProps["bpm"] | AlertModalProps["rpm"]
}

const InformativeIcon = ({
   iconColor,
   informativeIconItem,
}: {
   iconColor: IconColor
   informativeIconItem: InformativeIconItem
}) => {
   const { iconName /*, vitalValue */ } = informativeIconItem

   return (
      <span className="alert-modal__informative-vital">
         <Icon
            size="56"
            name={iconName}
            color={iconColor}
         />
         <span className="alert-modal__informative-vital-value">
            {/* vitalValue || */ "-"}
         </span>
      </span>
   )
}

export default InformativeIcon
